module.exports = __webpack_public_path__ + "img/circle-pause.a761d739.svg";